import { render } from "./LegalBlockEntry.vue?vue&type=template&id=06ed7fa5"
import script from "./LegalBlockEntry.vue?vue&type=script&lang=js"
export * from "./LegalBlockEntry.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__